module.exports = __webpack_public_path__ + "fonts/NotoSansGeorgian-Regular.f1aef4f0.woff2";